export default {
  langType: 'en_us',
  productName: 'Seer',
  slogan: 'Insight into life and know your fate',
  more: 'MORE INFORMATION',
  care: 'Follow us',
  contact: 'Contact us',
  copy: 'Copy Success',
  agreement: 'Service Agreement',
  policy: 'Privacy Policy',
  company: 'company：SEER ONNET PTE. LTD.',
  // Teacher Names
  林鹤: 'Lin He',
  易烊枫燧: 'Feng Sui',
  法銘道長: 'Fa Ming',
  赵振鸿: 'Master Chiu',
  道元: 'Mr. Daoyuan',
  // Teacher Tags
  实战派: 'Pragmatist',
  传道者: 'Preacher',
  执法者: 'Guardian',
  表演者: 'Practice Master',
  联结者: 'Linker',
  // Teacher Descriptions
  日常命运的解构者: 'Deconstructor of Daily Destiny',
  心性修行的引领者: 'Guide to Spiritual Cultivation',
  幽冥因果的沟通者: 'Mediator of Nether Karmic Links',
  现实成就的缔造者: 'Architect of Real-World Success',
  古今智慧的翻译师: 'Interpreter of Ancient & Modern Wisdom',
  // Skills
  四柱八字: 'Four Pillars',
  紫微斗数: 'Zi Wei Dou Shu',
  掌面相: 'Palmistry Face Reading',
  玄空风水: 'Feng Shui',
  环境风水: 'Feng Shui',
  梅花易数: 'Plum Blossom',
  手相面相: 'Palmistry & Physiognomy',
  天眼通: 'Heavenly Eye',
  六壬术法: 'Liu Ren',
  灵修导师: 'Spiritual Mentor',
  奇门遁甲: 'Qimen Dunjia',
  数字能量学: 'Number Energy',
  奇门术法: 'Qimen Esoteric',
  小六壬: 'Liu Ren',
  高端风水布局: 'Premium Feng Shui',
  八字命理: 'Bazi Astrology',
  风水堪舆: 'Feng Shui',
  铁板神数: 'IronPlate Numerology',
  // Academy Introduction
  academyIntro:
    'Academy of Superpower, co-founded by four eminent esoteric mentors — Feng Sui, Fa Ming, Dao Yuan and Zhen Hong — covers diverse Eastern and Western disciplines including Bazi (Four Pillars of Destiny), Feng Shui and magic, and is dedicated to delivering professional, reliable destiny guidance services to users.',
  // Academy Features
  academyFeature:
    'They are leading experts in superpowers and insightful mentors who tailor teaching to individual needs.\n\nUnlock your full potential, get a customized cultivation path, and break through your limits!\n\nThe academy\'s highlight is no gimmick, but the "superpower growth commitment" fulfilled by every mentor with solid capability!',
  recordUserComment:
    'Dec 31, 2024 ｜ Repaid half my karmic debt. Over 10 months, life improved: Settled well in Australia, away from conflicts; sold my stagnant Australian property at a minor loss. Hoping my other HK & overseas properties sell smoothly.🙏🏼😃',
  // Statistics
  recordUserCount: '200K',
  recordUserCountHighlight: '+',
  recordUserCountDesc: 'Real user',
  recordAccuracy: '98.2%',
  recordAccuracyHighlight: ' accuracy',
  recordAccuracyDesc: 'rated by our customers',
  recordScore: '4.8/5',
  recordScoreHighlight: ' stars',
  recordScoreDesc: 'average score',
  recordExpertCount: '100',
  recordExpertCountHighlight: '+',
  recordExpertCountDesc: 'Expert Team',
  // Video Related
  '《超能力学院》第一季': 'Superpower Academy: Season 1',
  videoTitle1:
    'Mentor Promo: "Superpower Academy" mentor Fa Ming makes a powerful entrance! Hear the unspoken words of the departed, slash through the mist of the School of Mysterious Learning with a single sword! Premiering June 14!',
  videoTitle2:
    'Mentor Promo: "Superpower Academy" Mentor Daoyuan Makes a High-Energy Debut! Mastering trends and shaping the future through the School of Mysterious Learning! Premiering June 14!',
  videoTitle3:
    'Superpower Academy Episode 1: Thrilling Audition Day! Ives Swallows Candles, Shocking Everyone! Witch Hainuo Successfully Meets Idol, But Rival Strikes? Ancestor Appears to Help, Linlong Kneels and Cries!',
  videoTitle4:
    'Superpower Academy Episode 4: Everyone Cursed on Audition Day, The Mastermind Revealed! 15 to 9, Teams Formed, School Officially Opens!',
  videoSeasonIntro:
    'Superpower Academy: The Ultimate Esoteric\nArena Where Reality Meets the Unknown!\n15 Rising Stars. 3 Legendary Masters. No\nScripts—Just Pure Competition.\nFight fate in trials. Validate your powers in duels.\nAwaken Your Hidden Potential—Right Here, Right Now!',
  followYouTube: 'Follow Superpower Academy on YouTube',
  // Service Related
  '看命盘/看八字': 'BaZi & Birth Chart Reading',
  service1Feature1: 'Orthodox Taoist · Zhengyi Sect Disciple',
  service1Feature2: '20 Years of Practical Experience · Served Over 10,000+ Students',
  service1Feature3: '1:1 Online Consultation, Get Your Initial Analysis in 30 Minutes',
  service1Description:
    'Personalized fortune consultation based on BaZi birth chart and profile analysis, designed to optimize your fortune and life path. Areas include relationship, career success and financial prosperity.',
  法事祈福: 'Prayer Ritual for Blessings',
  service2Feature1: 'Zhengyi Orthodox Blessing Rite · Prayer Document Stub Included',
  service2Feature2: 'Pre-Blessing Consult & Post-Ritual Support',
  service2Feature3: 'Hong Kong On-site Attendance Available & Online Video Playback',
  service2Description:
    'Authentic Taoist Blessing Ceremonies karmic resolution, home cleansing, career/wealth boost, health & peace. Led by Gao Gong priests to bless your fortune.',
  起名改名: 'Name Giving & Renaming',
  service3Feature1: 'BaZi Five Elements Precision Matching · No Random Words',
  service3Feature2: '3 Naming Options + Meaning Explanations · Editable & Selectable',
  service3Feature3: 'Business Name Matching Industry Traits · Boosting a Smooth Start',
  service3Description:
    'Fortune-Boosting Naming Service: Custom naming/renaming for infants, individuals & enterprises, rooted in Five Elements, BaZi and feng shui, to boost luck and attract good fortune.',
  风水布局: 'Feng Shui Layout',
  service4Feature1: 'On-site Inspection & Sha Identification · Reject Blind Online Judgment',
  service4Feature2: 'Actionable Furniture Arrangement & Feng Shui Decor Recommendations',
  service4Feature3: 'Shop Layout Optimized for Customer Flow · Driving Business Performance Growth',
  service4Description:
    'Space Energy ResetOn-site surveys for shops/offices/homes (Nine Palaces & Five Elements) — balance qi, dissolve sha, and attract wealth & blessings.',
  课程讲座: 'Courses & Lectures',
  service5Feature1: 'Theory + Case Analysis · No Empty Theories',
  service5Feature2: '1-on-1 Post-Course Support + Study Group · No Forgotten Skills',
  service5Feature3: 'Course Replays Available · Learn Continuously',
  service5Description:
    'Practical Metaphysics ProgramBaZi, Feng Shui & Date Selection — 20-Year Expert Live Classes + Offline Practice. Master usable skills.',
  择日: 'Auspicious Date Selection',
  service6Feature1:
    'Customized according to individual/enterprise BaZi, rejecting general almanacs',
  service6Feature2:
    '3 sets of auspicious date suggestions + auspicious time explanations, freely selectable',
  service6Feature3: 'Attached with simple auspicious notes + explanations of what to do and avoid',
  service6Description:
    'Using ancient Chinese metaphysical principles, we identify favorable dates and hours for significant events—from weddings to business launches—helping you align with cosmic rhythms for greater success and protection.',
  加whatsapp获取免费服务资格: 'Add WhatsApp to Get Free Service Access',
  // Comments Related
  精选好评直出睇完就知几得: 'Clients Love Our Services',
  // Comment 1
  comment1Name: 'Amber Wang',
  comment1Text:
    'A couple of months back, I joined a live session with Teacher Feng Sui on his YouTube program. He shared some practical tricks with me, and my business has seen a remarkable turnaround ever since. I want to extend my sincere thanks to him.',
  // Comment 2
  comment2Name: 'Ms. Su',
  comment2Text:
    "Wore Senior Brother Shanfan's Five-Element Bracelet for 2 months. A friend I hadn't met in 6 months said my complexion and energy are way better now—full of vitality! 👍🙏",
  // Comment 3
  comment3Name: 'Gnulnam Oh',
  comment3Text:
    "My old bedroom was in the Five Ghosts position. I'd always suffer from insomnia and feel unwell all over after sleeping there. Since I'm sensitive to energy, I moved to the living room—and my sleep improved right away! It wasn't until I learned Feng Shui with Teacher Feng Sui that I finally understood the root cause.",
  // Comment 4
  comment4Name: 'Kit Choi',
  comment4Text:
    'November 4th found me irritable and on edge. Yet from the 5th onward, my mood lifted noticeably. Despite enduring the same unfairness at work, I stayed calm—a simple breath was enough to reset! I felt a clear sense of lightness. Other shifts are still unfolding!',
  // Comment 5
  comment5Name: 'Vienie Bebelove',
  comment5Text:
    "A big thank you to you! Ever since I sent off the Tong Ren, I've definitely felt an improvement.",
  // Comment 6
  comment6Name: 'Ms. Tsai',
  comment6Text:
    'Better Mood, Less Negativity, Smoother Work! My Colleague Who Wore a Thai Amulet Suddenly Suffered from Gallstones and Took a One-Month Leave, Yet I Remained Energetic Despite Working Non-Stop for the Whole Month.',
  // Comment 7
  comment7Name: 'Sean Lee',
  comment7Text:
    'Thank you so much! I felt something quite magical the day after the session, and I really do feel lighter and in a much better mood.',
  // Comment 8
  comment8Name: 'Mr. Zhang',
  comment8Text:
    "Love Master Yi Yangfengsui! Professional, kind, and he helped me get rid of life's confusion. His answers are spot-on, he's super patient, no arrogance at all—highly recommended!",
  // Form Related
  立即获得免费服务资格: 'Get Free Service Qualification Now',
  告诉我们您的需求专业老师会在1个工作日为您服务:
    'Share Your Needs – Our Experts Will Assist You in 1 Business Day.',
  您的姓名: 'Your Name',
  请填写您的姓名: 'Please Fill in Your Full Name',
  您的WhatsApp: 'Your WhatsApp Contact',
  请填写您的WhatsApp: 'Please Fill in Your WhatsApp Contact',
  您的电话电邮: 'Your Contact Number / Email',
  请填写您的电话或电邮: 'Please Fill in Your Contact Number or Email',
  选择您想咨询的老师: 'Select the Mentor You Want to Consult',
  您想咨询的问题: 'The Question You Want to Ask',
  请简单描述您想咨询的问题: 'Please Briefly Outline the Matter You Want to',
  请选择老师: 'Please Select a Teacher',
  立即提交: 'Submit Now',
  提交成功: 'Submitted Successfully',
  提交失败: 'Submission Failed',
  我们会尽快与您联系: 'We will contact you as soon as possible',
  表单提交成功提示:
    'Your inquiry has been submitted successfully. We will contact you within one business day. Thank you for your patience.',
  表单提交失败提示: 'Submission failed. Please refresh the page and try again.',
  // Teacher Options
  teacher1Name: 'FengSui',
  teacher1Skills: 'Four Pillars, Environmental Feng Shui, Plum Blossom Divination, Palmistry',
  teacher2Name: 'Master Chiu',
  teacher2Skills: 'Bazi Astrology, Zi Wei Dou Shu, Palmistry, Xuan Kong Feng Shui',
  teacher3Name: 'FaMing',
  teacher3Skills: 'Heavenly Eye, Bone Reading, Zhuyou Technique',
  teacher4Name: 'Mr.Daoyuan',
  teacher4Skills: 'Number Energy, Qimen Magic, Liu Ren, Premium Feng Shui',
  // Footer Related
  联系我们: 'Contact Us',
  地址: 'Room 2003, 20/F, COFCO Tower, 262 Gloucester Road, Causeway Bay, Hong Kong',
  邮箱: 'chaonenglixueyuan@gmail.com',
  电话: '85284833986（Superpower Academy - Brother ShanSi）',
  营业时间: 'Open on weekdays, 10:00~19:00',
  品牌链接: 'Brand Links',
  加入先知命局: "Join the Prophet's Bureau",
  免费领取每日运势及会员福利: 'Receive daily horoscopes and member benefits for free',
  LINE给你: 'LINE for you',
  FollowUs: 'Follow Us',
  // Cooperative Media Related
  合作媒体: 'Cooperative Media',
  '电视台/广播电台': 'Television/Radio',
  线上串流平台: 'OTT Platforms',
  新媒体全渠道曝光: 'Multi-Channel New Media Exposure',
  '报道+网媒': 'Print and Online Media',
  '名师匠心打造+权威媒体精选': 'Master-Crafted+Media-Selected',
  超多服务选择全都帮你拆解难题解决烦恼:
    'Comprehensive Service Options to Resolve Your Challenges and Worries',
  挑选适合自己的服务白版说明:
    'Pick a service tailored to you. Get professional responses to all your questions!Share your life path and future plans freely, dive into talks about love,career choices and daily trivialities-speak your mind without holding back!',
  超十万次真实案例全实录: 'Over 100,000 Authentic Case Records',
  版权信息: '© 2025 Superpower Academy｜All Rights Reserved.',
  名师匠心打造: 'Master-Crafted',
  权威媒体精选: 'Media-Selected',
  超能力学院: 'The Soul of Academy of Superpower',
  金牌导师天团: 'Lies in Its All-Star Mentor Team',
  超多服务选择: 'Comprehensive Service Options',
  真实的口碑安心的服务: 'Genuine Reputation, Reliable Services',
  精选好评直出: 'Client Testimonials',
  睇完就知幾得: 'See How It Works',
  TaoistFengsui: 'TaoistFengsui',
  '赵振鸿Master Chiu': 'Master Chiu',
  法铭灵距离: 'Fa Ming',
  'Mr.DaoYuan': 'Mr.DaoYuan',
  立即下载: 'Download Now',
};
